export const getIconConfigForHref = ({ href, iconPosition = 'after', }) => {
    const isInternalLink = isInternalHref(href);
    let iconVariant;
    if (isInternalLink) {
        if (extensionIsDocument(href)) {
            iconVariant = 'document';
        }
        else if (iconPosition === 'before') {
            iconVariant = 'arrow-left';
        }
        else {
            iconVariant = 'arrow-right';
        }
    }
    else {
        iconVariant = 'external-link';
    }
    return {
        iconVariant,
        isIconInverted: iconPosition === 'before',
        isInternalLink,
    };
};
export const isInternalHref = (href) => {
    // Check if href is an url with http or www. without .anwb.nl
    if ((href.indexOf('http') > -1 || href.indexOf('www.') === 0) &&
        href.indexOf('.anwb.nl') === -1) {
        return false;
    }
    return true;
};
/**
 * This will check whether the extension is a document or not
 */
export const extensionIsDocument = (href) => {
    var _a;
    const documentExtensions = [
        'pdf',
        'doc',
        'docx',
        'ppt',
        'pptx',
        'xls',
        'xlsx',
        'txt',
        'json',
        'xml',
        'blob',
    ];
    const hrefParts = (_a = href.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    return hrefParts ? documentExtensions.includes(hrefParts) : false;
};
//# sourceMappingURL=getIconConfigForHref.js.map